<template>
<div class="chapter">
<div class="inner_page">
<div class="ded">
<p class="center"><em>To my granddaughter Jessica and her husband, Jake Strashok, who is what I have always secretly wanted to be: a metalsmith. And to my dear wife, Beverley, for being herself.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?4abb42d2